
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, StepperComponent } from '../../blocks';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { ControlsParams, UserSessionService } from '../../shared';
import { SecLogins, UsersGroupService } from './usersGroup.service';
import { UsersGroup } from './usersGroup';
import { AddUserGroupPopupComponent } from './add-user-group-popup/add-user-group-popup.component';

@Component({
    selector: 'sanabel-add-users-to-group',
    templateUrl: './add-users-group.component.html'
})

export class AddUsersGroupComponent implements OnInit, OnDestroy {
    SecLogins: SecLogins[];
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Output() callDetail: EventEmitter<number> = new EventEmitter<number>();
    @Input() myStepNumber: number;
    @Input() stepperComponent: StepperComponent;
    @Input() usersGroup: UsersGroup;
    @Input() userGroupCode: number;
    @ViewChild('popup') content: any;
    DynamicComponent: any;
    controlsParams: ControlsParams;
    groupID: number;
    editSecLogins: SecLogins = <SecLogins>{};
    constructor(
        private _usersGroupService: UsersGroupService,
        private _userSessionService: UserSessionService,
        public translate: TranslateService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
        //this.controlsParams = new ControlsParams(null, AppCodeGroup.Buttons, true, 'AddUserGroupPopupComponent', '');
        this._userSessionService.subscribeToKey$('groupParms')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys) {
                    if (keys.value) {
                        this.groupID = keys.value['groupID'];
                        this.getSecLogins();
                    }
                }
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getSecLogins() {
        if (this.groupID) {
            this._usersGroupService.getSecLoginsByGroupId(this.groupID)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    SecLogins => {
                        this.SecLogins = [];
                        this.SecLogins = SecLogins.data;
                    },
                    error => console.log(error),
                    () => {
                        null
                    });
        }
    }

    onRowSelect(event) {
        if (event.data) {
            this._userSessionService.setSessionKey('masterRow', event.data)
        }
    }

    addEditRow(secLogins: SecLogins) {
        // define object and in case of add set id null and groupId data
        let masterParms = <SecLogins>{}
        if (secLogins == null) {
            masterParms = <SecLogins>{ id: null, groupId: this.groupID }
        }
        // in edit case set params with object of SecLogins Data..
        else {
            masterParms = <SecLogins>{
                id: secLogins.id,
                userId: secLogins.userId,
                groupId: this.groupID,
                branchId: secLogins.branchId
            };
        }
        //send data when model open
        this.DynamicComponent = AddUserGroupPopupComponent;
        this.content.openModal("AddUserGroupPopupComponent", "masterParms", masterParms);
    }


    onRowIconClick(actionSerial: number, SecLogins: SecLogins) {
        if (actionSerial == 402) {
            this.addEditRow(SecLogins);
        }
        if (actionSerial == 403)
            this.delete(SecLogins);
    }

    delete(SecLogins: SecLogins) {
        if (SecLogins.id) {
            this._modalService.activeDelMes(SecLogins.id.toString(), SecLogins.id.toString()).then(responseOK => {
                if (responseOK) {
                    this._usersGroupService.deleteSecLogins(SecLogins)
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe(c => {
                        }, error => console.log(error),
                            () => this.getSecLogins());
                }
            });
        }
    }
    onpopupClose(parms: any) {
        // get data after model (Popup) close..
        this.getSecLogins();
        if (parms && parms.output == 'AddUserGroupPopupComponent') {
        }
    }

    updateStatus(editSecLogins: SecLogins) {
        if (editSecLogins.active) {
            editSecLogins.active = 0;
        }
        else {
            editSecLogins.active = 1;
        }
        if (editSecLogins.id) {
            this._usersGroupService.updateSecLogins(editSecLogins)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (c && c.returnFlag == true) {
                        this.getSecLogins();
                    }
                });
        }
    }
}
